import React, { Component } from 'react'
import styled from 'styled-components'
import { media } from 'styled-bootstrap-grid'
import easing from 'ui/styles/easing'

const ClockContent = styled.div`
  background: ${props => props.theme.colors.theme.base};
  padding: 25px;
  display: none;

  ${media.lg`
    display: block;
  `}
`

const Face = styled.div`
  width: 150px;
  height: 150px;
  border-radius: 100%;
  background: ${props => props.theme.colors.grey.lightest};
  flex-grow: 0;
  position: relative;
`

const Pivot = styled.div`
  width: 8px;
  height: 8px;
  position: absolute;
  top: 50%;
  left: 50%;
  background: ${props => props.theme.colors.theme.base};
  border-radius: 100%;
  transform: translateX(-50%) translateY(-50%);
`

const Hand = styled.div`
  width: 2px;
  position: absolute;
  bottom: 50%;
  left: 50%;
  transform: translateX(-50%) rotate(0);
  background: ${props => props.theme.colors.theme.base};
  transform-origin: bottom center;
`

const Hours = styled(Hand)`
  height: 30px;
  transform: translateX(-50%) rotate(${props => props.pos}deg);
  transition: transform 1s ${easing.easeOutCubic};
`

const Minutes = styled(Hand)`
  height: 45px;
  transform: translateX(-50%) rotate(${props => props.pos}deg);
  transition: transform 1s ${easing.easeOutCubic};
`

export default class Clock extends Component {
  state = {
    positions: []
  }

  componentDidMount() {
    this.getWatchPositions()
  }

  getWatchPositions() {
    const { times } = this.props

    const degHour = 360 / 12
    const degMinute = 360 / 60
    const adjustmentPerMinute = 0.5

    let positions = []

    times.map(time => {
      const adjustment = adjustmentPerMinute * time.minutes
      const posHours = time.hours * degHour + adjustment
      const posMinutes = (time.hours * 360) + (time.minutes * degMinute)

      return positions.push({posHours, posMinutes})
    })

    this.setState({positions})
  }

  render() {
    const { activeTime } = this.props
    const { positions } = this.state

    if(!positions.length) return null

    return(
      <ClockContent>
        <Face>
          <Pivot />
          <Minutes pos={positions[activeTime].posMinutes} />
          <Hours pos={positions[activeTime].posHours} />
        </Face>
      </ClockContent>
    )
  }
}



// WEBPACK FOOTER //
// ./src/ui/components/modules/DaySlider/Clock.js